import React from 'react';
import { DocumentWrapper } from 'components/Document/styled-components';

export interface DocumentProps {
  name: string;
  type: string;
  icon: JSX.Element;
  className?: any;
}

const Document: React.FC<DocumentProps> = (props): JSX.Element => {
  const { icon, name, type, className } = props;
  return (
    <DocumentWrapper {...props} className={className}>
      <div className="document-container">
        <div className="document">
          <span className="document-name">{name}</span>
          <span className="document-type">{type}</span>
        </div>
        {icon}
      </div>
    </DocumentWrapper>
  );
};

export default Document;
